import React from "react";
import {
	NavAndroid,
	NavApp,
	NavAppLink,
	NavArrow,
	NavIOS,
	NavLink,
	NavAppModal,
	NavAppModalIcons,
	NavQRCode,
} from "./styles";
import { Triangle, TriangleShadow } from "../../styles";
import getLangKeyValueFun from "utils/lang";
import langGroup from "assets/lang.json";
import { ANDROID_DOWNLOAD, APP_DOWNLOAD, IOS_DOWNLOAD } from "../../utils";

const getText = getLangKeyValueFun(langGroup);

interface MobileAppsProps {
	lowPriceCountryPriceOff: string;
}
class MobileApps extends React.Component<MobileAppsProps, {}> {
	/** 新页面打开 APP 下载页 */
	onOpenAppDownload = () => {
		window.open(APP_DOWNLOAD());
	};

	/** 新页面打开 iOS 商店页 */
	onOpenIOSDownload = () => {
		window.open(IOS_DOWNLOAD);
	};

	/** 新页面打开 Android 下载页 */
	onOpenAndroidDownload = () => {
		window.open(ANDROID_DOWNLOAD);
	};

	render() {
		const { lowPriceCountryPriceOff } = this.props;
		return (
			<NavApp>
				<NavLink
					dangerouslySetInnerHTML={{
						__html: lowPriceCountryPriceOff
							? lowPriceCountryPriceOff
							: `<b>${getText("10% OFF")}&nbsp;</b>${getText("for App User")}`,
					}}
					href={APP_DOWNLOAD()}
					target="_blank"
				/>
				<NavAppModal>
					<Triangle />
					<TriangleShadow />
					<NavAppModalIcons>
						<NavQRCode />
						<NavAppLink onClick={this.onOpenIOSDownload}>
							<NavIOS />
						</NavAppLink>
						<NavAppLink onClick={this.onOpenAndroidDownload}>
							<NavAndroid />
						</NavAppLink>
					</NavAppModalIcons>
				</NavAppModal>
				<NavArrow />
			</NavApp>
		);
	}
}

export default MobileApps;
